<div class="form-group">
  <input type="text" class="form-control" [formControl]="formControlRef"
         [disabled]="(productType === 6 && edit)? true: false" />
  <span class="text-danger" *ngIf="fieldErrors[fieldObject.fieldName] || fieldErrors[fieldErrorName]">
    {{ fieldErrors[fieldObject.fieldName] || fieldErrors[fieldErrorName] }}
  </span>
</div>
